import { releaseNotesInitialState, createReleaseNotesSlice } from '@sv-support-sdk/store';

const releaseNotes = createReleaseNotesSlice({
  name: 'releaseNotes',
  initialState: { ...releaseNotesInitialState },
  reducers: {},
});

export const releaseNotesActions = releaseNotes.actions;

export default releaseNotes.reducer;
